import React from "react";
import { ElementGroup } from '@whalecloud/page-builder-core/constant';
import TimePicker from "./components/TimePicker";
import TimePickerSettings from "./components/TimePickerSettings";
import { ReactComponent as PluginSvg } from "@assets/icons/time_picker_setting.svg";
import { getLocale, defaultTarget } from '@utils/util';

export default () => {
  const messages = getLocale();
  return {
    name: 'timePicker', // 插件名，不能包含空格,空格用-代替
    group: ElementGroup.SELECT, // 插件所在组，默认为ElementGroup.CUSTOM
    target: defaultTarget, // 插件所在目标层级，默认为["column", "row", "form"]
    title: messages['PAGEBUIDER_ELEMENT_FORM_TIMEPICKER'], // 插件标题
    toolBarPreview: <PluginSvg />, // 插件展示图标，不传则展示文字
    data: {
      formItemSettings: {
        allowClear: true,
        format: 'HH:mm:ss'
      },
      formSettings: {
        label: messages['PAGEBUIDER_ELEMENT_FORM_TIMEPICKER']
      },
      settings: {
        width: {
          value: "100%"
        },
      }
    },
    pluginComponent: TimePicker, // 插件渲染组件
    pluginSettingComponent: TimePickerSettings, // 插件设置项组件
  }
}
